import { render, staticRenderFns } from "./recursiveComponent.vue?vue&type=template&id=4cee0fa8&scoped=true"
import script from "./recursiveComponent.vue?vue&type=script&lang=js"
export * from "./recursiveComponent.vue?vue&type=script&lang=js"
import style0 from "./recursiveComponent.vue?vue&type=style&index=0&id=4cee0fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cee0fa8",
  null
  
)

export default component.exports